<!-- Pill variant -->
<div *ngIf="variant === 'pill'" class="inline-flex bg-primary px-2 py-2 rounded-lg gap-x-2">
  <ng-container *ngFor="let tab of tabs">
    <button
      *hasPermissions="tab.perms || ['none']"
      type="button"
      (click)="tabChange.emit(tab.value)"
      [ngClass]="activeTab === tab.value ? 'bg-white text-primary' : 'bg-primary text-white/95'"
      class="flex rounded-lg gap-x-2 h-[35px] items-center justify-center px-3 transition-all duration-200"
    >
      <span
        *ngIf="tab.iconPath"
        class="pill-icon"
        [style.webkitMaskImage]="'url(' + tab.iconPath + ')'"
        [style.maskImage]="'url(' + tab.iconPath + ')'"
      ></span>
      <i *ngIf="tab.matIcon && !tab.iconPath" class="material-icons" style="font-size:14px;width:14px;height:14px;line-height:14px;">{{ tab.matIcon }}</i>
      <span class="text-sm font-normal">{{ tab.label }}</span>
      <span *ngIf="tab.badge && tab.badge > 0" class="pill-badge">{{ tab.badge }}</span>
    </button>
  </ng-container>
</div>

<!-- Pill-outline variant -->
<div *ngIf="variant === 'pill-outline'" class="inline-flex gap-x-2">
  <ng-container *ngFor="let tab of tabs">
    <button
      *hasPermissions="tab.perms || ['none']"
      type="button"
      (click)="tabChange.emit(tab.value)"
      [ngClass]="activeTab === tab.value
        ? 'bg-primary text-white border-primary'
        : 'bg-transparent text-primary border-primary hover:bg-primary/10'"
      class="flex rounded-[10px] gap-x-2 h-[35px] items-center justify-center px-3 border transition-all duration-200"
    >
      <span
        *ngIf="tab.iconPath"
        class="pill-icon"
        [style.webkitMaskImage]="'url(' + tab.iconPath + ')'"
        [style.maskImage]="'url(' + tab.iconPath + ')'"
      ></span>
      <i *ngIf="tab.matIcon && !tab.iconPath" class="material-icons" style="font-size:14px;width:14px;height:14px;line-height:14px;">{{ tab.matIcon }}</i>
      <span class="text-sm font-normal">{{ tab.label }}</span>
      <span *ngIf="tab.badge && tab.badge > 0" class="pill-badge">{{ tab.badge }}</span>
    </button>
  </ng-container>
</div>

<!-- Underline variant -->
<div *ngIf="variant === 'underline'" class="flex items-center gap-8">
  <ng-container *ngFor="let tab of tabs">
    <button
      *hasPermissions="tab.perms || ['none']"
      type="button"
      (click)="tabChange.emit(tab.value)"
      class="flex items-center gap-2 text-sm transition-colors -mb-px rounded-none"
      [ngClass]="activeTab === tab.value
        ? 'border-b-2 border-primary font-semibold text-primary'
        : 'border-b-2 border-transparent font-medium text-gray-500 hover:text-primary'"
    >
      <span
        *ngIf="tab.iconPath"
        class="underline-tab-icon"
        [style.webkitMaskImage]="'url(' + tab.iconPath + ')'"
        [style.maskImage]="'url(' + tab.iconPath + ')'"
      ></span>
      <i
        *ngIf="tab.matIcon && !tab.iconPath"
        class="material-icons"
        [ngClass]="activeTab === tab.value ? 'opacity-100' : 'opacity-60'"
        style="font-size:18px;width:18px;height:18px;line-height:18px;"
      >{{ tab.matIcon }}</i>
      <span
        class="text-[13px] md:text-[14px] leading-none tracking-normal"
        [ngClass]="activeTab === tab.value ? 'font-bold' : 'font-normal'"
      >{{ tab.label }}</span>
      <span
        *ngIf="tab.badge && tab.badge > 0"
        class="underline-tab-badge"
        [class.underline-tab-badge--active]="activeTab === tab.value"
      >{{ tab.badge }}</span>
    </button>
  </ng-container>
</div>
